import { c as _c } from "react/compiler-runtime";
import { useDestination, useOrigin } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/hooks";
import { AutoCompleteInputPropertiesType } from "@website/accommodation-ui/tour-search-wrapper-group/tour-search-panel/auto-complete-input/types";
import { AutoComplete } from "@website/ui/auto-complete";
import { FC } from "react";
export const AutoCompleteInput: FC<AutoCompleteInputPropertiesType> = properties => {
  const $ = _c(27);
  const {
    cityFromInitial,
    cityToInitial,
    errors,
    onChangeDestination,
    onChangeOrigin,
    destinationSuggestions,
    originSuggestions
  } = properties;
  const {
    originLoading,
    originListNormalized,
    onSelectOrigin,
    onChangeOriginQuery,
    selectedOriginText,
    originQuery,
    OriginNoResult,
    originLabel
  } = useOrigin(cityFromInitial?.title || "", onChangeOrigin, originSuggestions);
  const {
    destinationLoading,
    destinationListNormalized,
    onSelectDestination,
    onChangeDestinationQuery,
    selectedDestinationText,
    destinationQuery,
    DestinationNoResult,
    destinationPlaceHolder,
    destinationLabel,
    destinationTags,
    destinationOnSelectTag
  } = useDestination(cityToInitial?.title || "", onChangeDestination, destinationSuggestions);
  const t0 = errors?.originError || errors?.destinationError;
  let t1;
  if ($[0] !== OriginNoResult || $[1] !== onChangeOriginQuery || $[2] !== onSelectOrigin || $[3] !== originLabel || $[4] !== originListNormalized || $[5] !== originLoading || $[6] !== originQuery || $[7] !== selectedOriginText) {
    t1 = {
      label: originLabel,
      list: originListNormalized,
      text: selectedOriginText,
      onSelect: onSelectOrigin,
      onChangeQuery: onChangeOriginQuery,
      query: originQuery,
      loading: originLoading,
      NoResult: OriginNoResult
    };
    $[0] = OriginNoResult;
    $[1] = onChangeOriginQuery;
    $[2] = onSelectOrigin;
    $[3] = originLabel;
    $[4] = originListNormalized;
    $[5] = originLoading;
    $[6] = originQuery;
    $[7] = selectedOriginText;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== DestinationNoResult || $[10] !== destinationLabel || $[11] !== destinationListNormalized || $[12] !== destinationLoading || $[13] !== destinationOnSelectTag || $[14] !== destinationPlaceHolder || $[15] !== destinationQuery || $[16] !== destinationTags || $[17] !== onChangeDestinationQuery || $[18] !== onSelectDestination || $[19] !== selectedDestinationText) {
    t2 = {
      list: destinationListNormalized,
      text: selectedDestinationText,
      onSelect: onSelectDestination,
      onChangeQuery: onChangeDestinationQuery,
      query: destinationQuery,
      loading: destinationLoading,
      NoResult: DestinationNoResult,
      disabled: false,
      placeholder: destinationPlaceHolder,
      label: destinationLabel,
      tags: destinationTags,
      onSelectTag: destinationOnSelectTag
    };
    $[9] = DestinationNoResult;
    $[10] = destinationLabel;
    $[11] = destinationListNormalized;
    $[12] = destinationLoading;
    $[13] = destinationOnSelectTag;
    $[14] = destinationPlaceHolder;
    $[15] = destinationQuery;
    $[16] = destinationTags;
    $[17] = onChangeDestinationQuery;
    $[18] = onSelectDestination;
    $[19] = selectedDestinationText;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== t1 || $[22] !== t2) {
    t3 = [t1, t2];
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== t0 || $[25] !== t3) {
    t4 = <AutoComplete error={t0} fullWidth={true} hideSearchBar={true} parts={t3} />;
    $[24] = t0;
    $[25] = t3;
    $[26] = t4;
  } else {
    t4 = $[26];
  }
  return t4;
};